export enum ChatUnavailableReason {
  NotAMember = 'NotAMember',
  RemovedParticipant = 'RemovedParticipant',
  RemovedOwner = 'RemovedOwner',
}
